import { useState, useEffect } from "react";
import {Routes, Route,} from 'react-router-dom';
import Records from "./pages/Records"
import Login from "./pages/Login"
import Users from "./pages/Users"
import Home from "./pages/Home"
import Reports from "./pages/Reports"
import Navbar from "./pages/Navbar"

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    setIsLoggedIn(false);
  };
  useEffect(() => {
    window.handleUnauthorized = handleLogout;
    return () => delete window.handleUnauthorized;
  }, []);

  if (!isLoggedIn) {
    return <Login onLogin={() => setIsLoggedIn(true)} />;
  }
  return (
    <>
      <Navbar />
      <div className='pt-20'></div>
      <Routes>
          <Route path='/' element={<Home />}/> |{" "}
          <Route path='/records' element={<Records />}/> |{" "}
          <Route path='/users' element={<Users />}/>
          <Route path='/users/edit/:id' element={<Users />}/>
          <Route path='/reports' element={<Reports />}/>
      </Routes>
    </>
  );
}

export default App